import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
// material-ui
import { styled } from '@mui/material/styles';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Button, Dialog, IconButton, TextField, Slide } from '@mui/material';
import { toast } from 'react-toastify';
import ApiCall from '../../utils/Api';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

const BootstrapDialogTitle = ({ children, onClose, ...other }) => (
  <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
    {children}
    {onClose ? (
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 10,
          top: 10,
          color: "white"
        }}
      >
        {/* <CloseIcon /> */}
      </IconButton>
    ) : null}
  </DialogTitle>
);

BootstrapDialogTitle.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node
};

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} timeout={1000} />);

export default function Edit_Email_FundSubscriber_By_Admin({ fundSubscriberEmail, setUpdateCount, updateCount, id }) {
  const [open, setOpen] = useState(false);
  const [Email, setEmail] = useState("");
  const [EmailValidation, setEmailValidation] = useState("");

  const updateData = async () => {
    try {
      if (!Email) {
        setEmailValidation("Please enter email");
        return;
      }
      
      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(Email)) {
        setEmailValidation("Please enter a valid email address");
        return;
      }
      
      setEmailValidation("");

      const data = await ApiCall.SECURE_API.put(`/admin/editFundSubscriber/${id}`, {
        email: Email,
      });
      
      if (data.data.success) {
        toast.success("Email updated successfully");
        handleClose();
        if (setUpdateCount) {
          setUpdateCount(updateCount + 1);
        }
      }
    } catch (error) {
      console.error("Error updating email:", error);
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to update email");
      }
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEmailValidation("");
  };

  useEffect(() => {
    setEmail(fundSubscriberEmail || "");
  }, [fundSubscriberEmail]);

  return (
    <div>
      <Button variant="outlined" onClick={handleClickOpen}>
        EDIT
      </Button>
      <BootstrapDialog
        fullWidth="sx"
        TransitionComponent={Transition}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <BootstrapDialogTitle
          sx={{ position: 'relative', color: 'black', fontSize: 20 }}
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Edit Email
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", width: "100%" }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 10 }}>
              <TextField
                value={Email}
                error={!!EmailValidation}
                helperText={EmailValidation}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setEmailValidation("");
                }}
                type="email"
                style={{ width: "90%" }}
                id="outlined-basic"
                label="Enter Email"
                variant="outlined"
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={updateData} autoFocus variant="contained" color="primary">
            SAVE
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}

Edit_Email_FundSubscriber_By_Admin.propTypes = {
  fundSubscriberEmail: PropTypes.string,
  setUpdateCount: PropTypes.func,
  updateCount: PropTypes.number,
  id: PropTypes.string.isRequired
};


